var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubstract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44ZM17.4142 20.4852C16.6332 19.7042 15.3668 19.7042 14.5858 20.4852C13.8047 21.2662 13.8047 22.5326 14.5858 23.3136L20.2426 28.9705L30.1421 19.071C30.9232 18.2899 30.9232 17.0236 30.1421 16.2426C29.3611 15.4615 28.0948 15.4615 27.3137 16.2426L20.2426 23.3136L17.4142 20.4852Z",
    fill: "#0B907B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstract);
export default __webpack_public_path__ + "static/media/substract.6b712161773199da8f2f3e686ce7b4bb.svg";
export { ForwardRef as ReactComponent };